import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {

  transform(
    value: string, 
    maxLength: number = 30, 
    type: 'general' | 'email' | 'filename' = 'general',
    suffix: string = '...'
  ): string {
    if (!value) return '';
    
    if (value.length <= maxLength) return value;

    switch (type) {
      case 'email':
        return this.truncateEmail(value, maxLength, suffix);
      case 'filename':
        return this.truncateFilename(value, maxLength, suffix);
      case 'general':
      default:
        return value.substring(0, maxLength).trim() + suffix;
    }
  }

  private truncateEmail(email: string, maxLength: number, suffix: string): string {
    const atIndex = email.lastIndexOf('@');
    if (atIndex === -1) return email.substring(0, maxLength).trim() + suffix;
    
    const domain = email.substring(atIndex);
    const localPart = email.substring(0, atIndex);
    
    if (domain.length >= maxLength - suffix.length) {
      return email.substring(0, maxLength).trim() + suffix;
    }
    
    const availableForLocal = maxLength - domain.length - suffix.length;
    if (localPart.length > availableForLocal) {
      return localPart.substring(0, availableForLocal) + suffix + domain;
    }
    
    return email;
  }

  private truncateFilename(filename: string, maxLength: number, suffix: string): string {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) return filename.substring(0, maxLength).trim() + suffix;
    
    const extension = filename.substring(lastDotIndex);
    const nameWithoutExt = filename.substring(0, lastDotIndex);
    
    if (extension.length >= maxLength - suffix.length) {
      return filename.substring(0, maxLength).trim() + suffix;
    }
    
    const availableForName = maxLength - extension.length - suffix.length;
    if (nameWithoutExt.length > availableForName) {
      return nameWithoutExt.substring(0, availableForName) + suffix + extension;
    }
    
    return filename;
  }
}
